import { IconLink } from '@consta/icons/IconLink'
import type { Props as ButtonProps } from '@consta/uikit/Button'
import { Button } from '@consta/uikit/Button'
import { Publishing } from '@core/components'
import { createUrlTo } from '@library/model'
import type { ProjectId } from 'common/types'
import type { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import css from './SidebarControls.css'
import type { ISidebarControl } from './types'

const buttonProps: ButtonProps = {
  view: 'ghost',
  size: 's',
  onlyIcon: true,
}

const handleLink = (id: ProjectId) =>
  navigator.clipboard.writeText(createUrlTo({ base: 'Project', path: id, full: true }))

export const SidebarControls: FC<ISidebarControl> = ({ projectData }) => {
  const navigate = useNavigate()

  const handleOpenClick = () => {
    navigate(createUrlTo({ base: 'Project', path: projectData.id }))
  }

  const onClick = () => void handleLink(projectData.id)

  return (
    <div className={css.sidebarControls}>
      <Button label="Открыть проект" size="s" onClick={handleOpenClick} />
      <div>
        <Publishing
          projectId={projectData.id}
          name={projectData.name}
          projectType={projectData.type}
          state={projectData.state}
          createdBy={projectData.createdBy}
          {...buttonProps}
        />
        <Button className={css.btnMargin} iconLeft={IconLink} {...buttonProps} onClick={onClick} />
      </div>
    </div>
  )
}
